import { render, staticRenderFns } from "./purchaseReturnReviewList.vue?vue&type=template&id=4b58b8e6&scoped=true"
import script from "./purchaseReturnReviewList.vue?vue&type=script&lang=js"
export * from "./purchaseReturnReviewList.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnReviewList.vue?vue&type=style&index=0&id=4b58b8e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b58b8e6",
  null
  
)

export default component.exports